import Link from "@/components/Link";
import { getBlogAuthorUrl } from "@/lib/blog";

interface AuthorDisplayProps {
  author?: {
    slug: string;
    title: string;
  } | null;
  className?: string;
  showByPrefix?: boolean;
  defaultAuthor?: {
    slug: string;
    title: string;
  };
}

export default function AuthorDisplay({ 
  author, 
  className = "uppercase text-lg md:text-xl",
  showByPrefix = false,
  defaultAuthor = {
    slug: 'meet-dr-harmon',
    title: 'Dr. Jeffrey Harmon'
  }
}: AuthorDisplayProps) {
  // Use provided author or default
  const displayAuthor = author || defaultAuthor;
  const authorUrl = getBlogAuthorUrl(displayAuthor.slug);

  if (showByPrefix) {
    return (
      <span className="mr-1">
        by{" "}
        {authorUrl ? (
          <Link href={authorUrl} className={className}>
            {displayAuthor.title}
          </Link>
        ) : (
          <span className={className}>{displayAuthor.title}</span>
        )}
      </span>
    );
  }

  return (
    <>
      {authorUrl ? (
        <Link href={authorUrl} className={className}>
          {displayAuthor.title}
        </Link>
      ) : (
        <span className={className}>
          {displayAuthor.title}
        </span>
      )}
    </>
  );
} 